import { FILTERS, DEFAULT_FILTER_OPTIONS } from '../../../../../common/filters/constants';
import { getBeginningOfDay } from '../../../../../../constants/helpers/dates';

import { SmsBillingFilters } from './interfaces';

export const initFilters: SmsBillingFilters = {
  [FILTERS.PAGE_SIZE]: DEFAULT_FILTER_OPTIONS.PAGE_SIZE,
  [FILTERS.FROM]: getBeginningOfDay(),
  [FILTERS.OPERATOR]: [],
  [FILTERS.TO]: 'now',
  [FILTERS.OPERATION_ID]: [],
  [FILTERS.STATUS]: [],
  [FILTERS.RECIPIENT_MSISDN]: []
};

export const activeFiltersCountMapper = (activeFilters: SmsBillingFilters) => {
  let availableFiltersCount = 0;

  if (activeFilters.operation_id?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.operator?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.status?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.recipient_msisdn?.length > 0) {
    availableFiltersCount += 1;
  }
  return availableFiltersCount;
};
